import React from 'react';
import { ToggleSection } from '@/components/form/ToggleSection';
import { CancellationPolicyConfig } from './CancellationPolicyConfig';

type CancellationRule = {
  days: number | null;
  type: "percentage" | "fixed";
  value: number | null;
};

interface CancellationPolicySectionProps {
  localUseCancellationPolicy: boolean;
  cancellationPolicy: CancellationRule[];
  paymentTermsDays: number | null;
  onToggleCancellationPolicy: (checked: boolean) => void;
  onCancellationPolicyChange: (newRules: CancellationRule[]) => void;
  onDeactivate?: () => void;
}

export const CancellationPolicySection: React.FC<CancellationPolicySectionProps> = ({
  localUseCancellationPolicy,
  cancellationPolicy,
  paymentTermsDays,
  onToggleCancellationPolicy,
  onCancellationPolicyChange,
  onDeactivate,
}) => {
  return (
    <ToggleSection
      id="useCancellationPolicy"
      label="Apply Shift Cancellation Policy"
      description="Charge a penalty when a client cancels a confirmed shift"
      checked={localUseCancellationPolicy}
      onCheckedChange={onToggleCancellationPolicy}
      variant="indented"
    >
      <CancellationPolicyConfig
        policy={cancellationPolicy}
        onChange={onCancellationPolicyChange}
        paymentTermsDays={paymentTermsDays}
        onDeactivate={onDeactivate}
      />
    </ToggleSection>
  );
};
